// extracted by mini-css-extract-plugin
export default {"sub_header_info":"sub-header-info_sub_header_info__V2LpB","icon_img":"sub-header-info_icon_img__aAh3q","text_info":"sub-header-info_text_info__W0tMj"};